import Select, { GroupBase, Props } from "react-select";
import styled, { css } from "styled-components";

export const StyledSelect = styled(Select)<{ hasError?: boolean }>`
  ${(props) => css`
    min-width: 0;
    .Select__control {
      border-radius: 0 1.2rem;
      border: 1px solid
        ${props.hasError
          ? props.theme.colors.secondary_error
          : props.theme.colors.primary_light_gray};
      background-color: ${props.theme.colors.basic_white};
      font-size: 1.6rem;

      &--is-focused {
        box-shadow: none;
        border-color: ${props.hasError
          ? props.theme.colors.secondary_error
          : props.theme.colors.primary_red};
      }

      &--is-disabled {
        opacity: 0.5;
      }

      &:hover {
        border-color: ${props.theme.colors.primary_red};
      }
    }

    .Select__value-container {
      padding: 13px;
    }

    .Select__indicator-separator {
      display: none;
    }

    .Select__placeholder {
      color: ${props.theme.colors.primary_light_gray};
      font-size: 1.6rem;
    }

    .Select__menu {
      margin: 0;
      border: none;
      padding: 0;
      box-shadow: ${props.theme.shadow["20dp"]};
      border-radius: 0.8rem;
      font-size: 1.6rem;
      &-notice {
        &--no-options {
          padding: 1.6rem;
        }
      }
    }

    .Select__option {
      color: ${props.theme.colors.basic_black};
      font-size: 1.6rem;
      padding: 1.6rem;

      &--is-focused {
        background-color: #f5f5f5;
      }
      &--is-selected {
        color: ${props.theme.colors.primary_red};
        background-color: white;
      }
    }
  `}
`;

export default function CustomSelect<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>({
  hasError,
  ...props
}: Props<Option, IsMulti, Group> & {
  hasError?: boolean;
}) {
  // @ts-ignore
  return (<StyledSelect classNamePrefix="Select" {...props} hasError={hasError} />);
}
